import { MAKE_VARIANT_CAPABILITIES } from '@/constant/makeWorksheet/variant'

import { getMakeVariant } from './makeVariantSearch'

/** step3 "문제 영역 옵션" 산출물 플래그 전체 off 셋 */
export const PROBLEM_AREA_OPTION_FLAGS_OFF = {
  conceptNameFlag: false,
  answerRateFlag: false,
  problemTrendFlag: false,
  relationWorkbookFlag: false,
  wrongAnswerNoteFlag: false,
} as const

/**
 * showProblemAreaOptions=false 모드에서 강제 off 오버라이드.
 * UI 비노출만으로는 localStorage 복원·디자인 템플릿 적용 경로로 true가 유입될 수 있어
 * 값 자체를 강제 off 해 봉인한다.
 */
export const getProblemAreaOptionsOverride = (search: string) =>
  MAKE_VARIANT_CAPABILITIES[getMakeVariant(search)].showProblemAreaOptions
    ? {}
    : PROBLEM_AREA_OPTION_FLAGS_OFF
